import axios from 'axios'
import { call, put } from '@redux-saga/core/effects'
import { roomsSuccess, roomsError } from '../../../actions/rooms/actions'
import { PageSet } from '../../../types'
import { Action } from '../../../../common/store/sagas/root'
import { getRooms } from '../../../api/roomsGetter'
import { PaginatedResponse } from '../../../../types'

export function* sagaGetRooms({ payload }: Action<PageSet>) {
  try {
    const response: PaginatedResponse = yield call(getRooms, payload)
    yield put(roomsSuccess(response))
  } catch (error) {
    if (axios.isAxiosError(error) && error.response) {
      yield put(roomsError(error.response.data as unknown))
    } else {
      yield put(roomsError(error))
      throw error
    }
  }
}
